
import React from 'react';
import { useTranslationUtils } from '@/hooks/useTranslationUtils';
import { EventFilterOptions } from '@/types/events';
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Search } from 'lucide-react';

interface EventsFilterProps {
  filterOptions: EventFilterOptions;
  onFilterChange: (filters: Partial<EventFilterOptions>) => void;
}

const EventsFilter: React.FC<EventsFilterProps> = ({ filterOptions, onFilterChange }) => {
  const { t } = useTranslationUtils();

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onFilterChange({ searchQuery: e.target.value });
  };

  const handleShowFestiPassOnlyChange = (checked: boolean) => {
    onFilterChange({ showFestiPassOnly: checked });
  };

  const handleShowUpcomingOnlyChange = (checked: boolean) => {
    onFilterChange({ showUpcomingOnly: checked });
  };

  return (
    <div className="space-y-4">
      <div className="relative">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          type="text"
          placeholder={t('admin.searchEvents')}
          value={filterOptions.searchQuery || ''}
          onChange={handleSearchChange}
          className="pl-8"
        />
      </div>
      
      <div className="flex flex-wrap gap-6">
        <div className="flex items-center space-x-2">
          <Switch
            id="show-festi-pass"
            checked={filterOptions.showFestiPassOnly}
            onCheckedChange={handleShowFestiPassOnlyChange}
          />
          <Label htmlFor="show-festi-pass">{t('events.festiPass')}</Label>
        </div>
        
        <div className="flex items-center space-x-2">
          <Switch
            id="show-upcoming"
            checked={filterOptions.showUpcomingOnly}
            onCheckedChange={handleShowUpcomingOnlyChange}
          />
          <Label htmlFor="show-upcoming">{t('events.upcoming')}</Label>
        </div>
      </div>
    </div>
  );
};

export default EventsFilter;
